import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=c4e58c4e&scoped=true"
import script from "@/views/Subjects/Notes.ts?vue&type=script&lang=ts&external"
export * from "@/views/Subjects/Notes.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Subjects/notes.scss?vue&type=style&index=0&id=c4e58c4e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e58c4e",
  null
  
)

export default component.exports